/* Pfanner — product card interactions (reference `.prod` cards).
   Two jobs, both progressive-enhancement over the server-rendered markup:

   1. Merken (wishlist) heart — .prod__fav toggles window.PfannerWishlist
      (pfanner-wishlist.js). Storage/sync/header-badge all stay on that engine;
      this file only reflects + toggles state on the card hearts. Falls back to a
      localStorage write (same key + change event) if the engine hasn't loaded yet,
      so a card heart is never dead.

   2. Add-to-cart micro-interaction — .prod__add pops the card (.prod--pop) and
      flies a "+1" chip to the header cart (#cart-icon-bubble). The actual add is
      handled by Dawn's <product-form>; this only decorates the click. Fully
      disabled under prefers-reduced-motion (CSS also guards .prod--pop/.fly-cart).

   Loaded ONCE from layout/theme.liquid. It used to be included per-section from
   snippets/card-product.liquid, but Dawn's <product-recommendations> (PDP related
   products, cart cross-sell) swaps its markup in via `innerHTML`, and a <script>
   inserted that way is never executed — so this file never ran on a PDP and every
   heart in that row was dead. The window flag below keeps any stray include a
   harmless no-op. */

(function () {
  'use strict';
  if (window.__pfannerCards) return;
  window.__pfannerCards = true;

  var WKEY = 'pfanner:wishlist';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- wishlist state (localStorage is the source of truth; order-independent) ---- */
  function wlList() {
    try {
      var v = JSON.parse(localStorage.getItem(WKEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function wlHas(h) {
    return wlList().indexOf(h) >= 0;
  }
  function wlToggle(h) {
    if (window.PfannerWishlist && typeof window.PfannerWishlist.toggle === 'function') {
      return window.PfannerWishlist.toggle(h);
    }
    // Fallback: mirror pfanner-wishlist.js's storage contract exactly.
    var items = wlList();
    var i = items.indexOf(h);
    var added = i < 0;
    if (added) items.push(h);
    else items.splice(i, 1);
    localStorage.setItem(WKEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('pfanner:wishlist:change', { detail: { handles: items } }));
    return added;
  }

  function paintFav(btn) {
    var h = btn.getAttribute('data-wishlist-handle');
    if (!h) return;
    var on = wlHas(h);
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', String(on));
    btn.style.color = on ? 'var(--pfanner-red, #C8161D)' : '';
    var svg = btn.querySelector('svg');
    if (svg) svg.setAttribute('fill', on ? 'currentColor' : 'none');
  }
  function paintAllFav() {
    var list = document.querySelectorAll('.prod__fav[data-wishlist-handle]');
    for (var i = 0; i < list.length; i++) paintFav(list[i]);
  }

  /* ---- add-to-cart pop + fly-to-cart ---- */
  function cartFx(btn) {
    var card = btn.closest('.prod');
    if (card && !reduce.matches) {
      card.classList.remove('prod--pop');
      void card.offsetWidth; // restart the animation
      card.classList.add('prod--pop');
    }
    if (reduce.matches) return;

    var cart = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
    if (!cart) return;
    var a = btn.getBoundingClientRect();
    var b = cart.getBoundingClientRect();
    var fly = document.createElement('div');
    fly.className = 'fly-cart';
    fly.textContent = '+1';
    fly.style.left = a.left + a.width / 2 + 'px';
    fly.style.top = a.top + a.height / 2 + 'px';
    document.body.appendChild(fly);
    requestAnimationFrame(function () {
      var dx = b.left + b.width / 2 - (a.left + a.width / 2);
      var dy = b.top + b.height / 2 - (a.top + a.height / 2);
      fly.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.4)';
      fly.style.opacity = '0';
    });
    setTimeout(function () {
      fly.remove();
    }, 720);
    if (navigator.vibrate) {
      try {
        navigator.vibrate(20);
      } catch (e) {}
    }
  }

  /* ---- delegated handlers (cover cards in every section, incl. late ones) ---- */
  document.addEventListener('click', function (e) {
    var fav = e.target.closest && e.target.closest('.prod__fav');
    if (fav) {
      // Heart sits outside the media anchor, but stop just in case of nesting.
      e.preventDefault();
      e.stopPropagation();
      var h = fav.getAttribute('data-wishlist-handle');
      if (h) {
        wlToggle(h);
        paintFav(fav);
      }
      return;
    }
    // Do NOT preventDefault here — the <product-form> submit must proceed.
    var add = e.target.closest && e.target.closest('.prod__add');
    if (add && !add.disabled && add.getAttribute('aria-disabled') !== 'true') {
      cartFx(add);
    }
  });

  document.addEventListener('pfanner:wishlist:change', paintAllFav);

  /* Cards can arrive AFTER init: <product-recommendations> and the cart cross-sell
     replace their own innerHTML, and the collection sections append pages of cards.
     Without this, a product already on the Merkliste renders with an empty heart in
     those rows (the click handler is delegated, so it keeps working either way).
     Coalesced so a big innerHTML swap costs one pass. Deliberately setTimeout and
     not requestAnimationFrame: rAF is paused in background tabs, and a PDP opened
     in one (cmd-click) would sit with unpainted hearts until it is focused. */
  var repaintQueued = false;
  function queueRepaint() {
    if (repaintQueued) return;
    repaintQueued = true;
    setTimeout(function () {
      repaintQueued = false;
      paintAllFav();
    }, 0);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('.prod__fav')) || (n.querySelector && n.querySelector('.prod__fav'))) {
            queueRepaint();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    paintAllFav();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
